<template>
    <main v-if="data && data.conferences">
        <div class="infoBar">
            <WebsiteBreadcrumbs>
                <a>conferences</a>
            </WebsiteBreadcrumbs>
        </div>
        <div class="lastConference">
            <ItemConferenceNext :conference="data.conferences.slice(0, 1)[0]" />
        </div>
        <a id="past-conferences"></a>
        <div class="conferences">
            <h2 class="baron headerText">past conferences</h2>
            <div class="grid">
                <ItemConference v-for="conference in data.conferences.slice(1)" :conference="conference" />
            </div>
        </div>
        <WebsiteFooter />
    </main>
</template>

<script lang="ts" setup>
const { getConferencesPage } = useConferences();
const { data } = useAsyncData('conferences', () => getConferencesPage());

useSeoMeta({
    title: 'Conferences | EIC Federation',
    ogTitle: 'Conferences | EIC Federation',
    twitterTitle: 'Conferences | EIC Federation',
})
</script>

<style lang="scss" scoped>
main {
    padding-top: var(--size-padding-header);

    .infoBar {
        padding: 0 var(--size-margin-page);
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: var(--size-margin-page);

        margin-bottom: var(--size-gutter-default);
        color: var(--color-primary);
    }

    .lastConference {
        padding: 0 var(--size-margin-page) var(--size-gutter-sections) var(--size-margin-page);
    }

    .conferences {
        margin: 0 var(--size-margin-page);

        display: flex;
        flex-direction: column;
        gap: var(--size-gutter-double);

        h2 {
            border-top: var(--size-thickness) solid var(--color-primary);
            font-weight: normal;
            color: var(--color-primary);
            padding-top: var(--size-margin-page);
            text-wrap: balance;
        }

        .grid {
            display: grid;
            grid-template-columns: repeat(5, minmax(0, 1fr));
            gap: var(--size-gutter-double) var(--size-margin-page);
        }
    }
}

@media screen and (max-width: 1280px) {
    main {
        .conferences {
            .grid {
                grid-template-columns: repeat(4, minmax(0, 1fr));
                gap: var(--size-gutter-double) var(--size-margin-page);
            }
        }
    }
}

@media screen and (max-width: 1024px) {
    main {
        .conferences {
            .grid {
                grid-template-columns: repeat(3, minmax(0, 1fr));
                gap: var(--size-gutter-double) var(--size-margin-page);
            }
        }
    }
}

@media screen and (max-width: 768px) {
    main {
        .conferences {
            .grid {
                grid-template-columns: repeat(2, minmax(0, 1fr));
                gap: var(--size-gutter-double) var(--size-margin-page);
            }
        }
    }
}

@media screen and (max-width: 600px) {
    main {
        .infoBar {
            grid-template-columns: 1fr;
        }

        .conferences {
            .grid {
                grid-template-columns: repeat(1, minmax(0, 1fr));
                gap: var(--size-gutter-double) var(--size-margin-page);
            }
        }
    }
}


</style>